export default class WorkTypeMetricNames {
    static CREATE_ATTEMPT = "CreateWorkTypeAttempt";
    static CREATE_FAILURE = "CreateWorkTypeFailure";
    static GET_BY_ID_ATTEMPT = "GetWorkTypeByIdAttempt";
    static GET_BY_ID_FAILURE = "GetWorkTypeByIdFailure";
    static GET_BY_GROUP_ID_AND_VERSION_ATTEMPT = "GetWorkTypeByGroupIdAndVersionAttempt";
    static GET_BY_GROUP_ID_AND_VERSION_FAILURE = "GetWorkTypeByGroupIdAndVersionFailure";
}
